import React from 'react';
import { Link } from 'react-router-dom';
import originalLogo from '../media/js_logo_60px.svg';
import GamesMenu from './GamesMenu';
import BrandMark from '../BrandMark';
export default function Header() {
  return <header className="site-header"><Link to="/" className="wordmark" aria-label="Drink If You Think home"><BrandMark compact /><span className="sr-only">Drink If You Think</span></Link><div className="header-tools"><img className="brand-logo" src={originalLogo} alt="Just Recess Games" /><GamesMenu /></div></header>;
}
